{
  "title": "Sending",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level evocation",
  "level": 3,
  "castingTime": "1 action",
  "range": "Unlimited",
  "components": "V, S, M (a short piece of fine copper wire)",
  "duration": "1 round",
  "description": [
    "You send a short message of twenty-five words or less to a creature with which you are familiar. The creature hears the message in its mind, recognizes you as the sender if it knows you, and can answer in a like manner immediately. The spell enables creatures with Intelligence scores of at least 1 to understand the meaning of your message.",
    "You can send the message across any distance and even to other planes of existence, but if the target is on a different plane than you, there is a 5 percent chance that the message doesn't arrive."
  ],
  "spellLists": ["bard", "cleric", "eldritch-knight", "wizard"]
}
